namespace Matrix.Scheduling {
    export interface CalendarRow {
        CalendarCode?: string;
        Name?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace CalendarRow {
        export const idProperty = 'CalendarCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Scheduling.Calendar';
        export const lookupKey = 'Scheduling.Calendar';

        export function getLookup(): Q.Lookup<CalendarRow> {
            return Q.getLookup<CalendarRow>('Scheduling.Calendar');
        }
        export const deletePermission = 'DataAdmin:Calendar';
        export const insertPermission = 'DataAdmin:Calendar';
        export const readPermission = 'Read:Calendar';
        export const updatePermission = 'DataAdmin:Calendar';

        export declare const enum Fields {
            CalendarCode = "CalendarCode",
            Name = "Name",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
